/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Release_LabelInputs */



/**
* | output |
* | --- |
* | "Release" |
*
* @param {Audio_Description_Export_Automix_Release_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_release_label = /** @type {((inputs?: Audio_Description_Export_Automix_Release_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Release_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Relâchement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Freigeben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblicazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выпускать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Liberar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发布")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リリース")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मुक्त करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Liberar")
	return /** @type {LocalizedString} */ ("Release")
});